export default __webpack_public_path__ + "static/media/attribution.3b8071f1.txt";